var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5681 59.3526V34.9217H71.5516V83.3572H79.2842C81.4276 77.1354 87.3366 72.651 94.2773 72.651C101.218 72.651 107.127 77.1354 109.27 83.3572H117V59.3526H83.5681Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.304 34.9217H90.4237V52.4971H105.34L99.304 34.9217Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.898 97.0924C101.655 95.6508 104.343 90.6257 102.902 85.8685C101.46 81.1112 96.4348 78.4233 91.6776 79.8649C86.9203 81.3065 84.2325 86.3317 85.6741 91.0889C87.1157 95.8461 92.1408 98.534 96.898 97.0924Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 65.7819V83.3573H7.72977C9.87325 77.1355 15.7822 72.6511 22.7227 72.6511C29.6632 72.6511 35.5723 77.1353 37.7156 83.3573H64.6962V65.7819H0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7227 97.508C27.6937 97.508 31.7235 93.4783 31.7235 88.5073C31.7235 83.5363 27.6937 79.5065 22.7227 79.5065C17.7517 79.5065 13.7219 83.5363 13.7219 88.5073C13.7219 93.4783 17.7517 97.508 22.7227 97.508Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f4c99f0cd5b67e4d4ad2d85464849062.svg";
export { ForwardRef as ReactComponent };